/**
 * Identidad de personas: el email es la clave en todo el BO (Cognito, community
 * map, D-Talk, Mapa de Talento, Vault). Se compara SIEMPRE normalizado.
 *
 * Auditoría 18/09/2026: `(email || '').trim().toLowerCase()` estaba escrito 20
 * veces; un `emailOf` vivía en talent-map-universe y un `lower` en cada store
 * de governance. Cuando una copia olvida el trim, "Juan@Winclap.com " no matchea
 * y la persona "no tiene líder" o "no tiene acceso".
 *
 * Pura, sin dependencias. Tests: `npm run test:identity`.
 */

/** Email listo para comparar/indexar: trim + minúsculas. Nulo/undefined ⇒ ''. */
export function normalizeEmail(e: string | null | undefined): string {
  return (e || '').trim().toLowerCase(); // reuse-ok: ESTA es la implementación compartida
}

/** ¿Son la misma persona? (ambos no vacíos y normalizados iguales) */
export function sameEmail(a: string | null | undefined, b: string | null | undefined): boolean {
  const x = normalizeEmail(a);
  return !!x && x === normalizeEmail(b);
}

/** ¿Está el email en la lista? (lista normalizada al vuelo) */
export function emailInList(e: string | null | undefined, list: readonly string[] | null | undefined): boolean {
  const x = normalizeEmail(e);
  return !!x && (list ?? []).some((l) => normalizeEmail(l) === x);
}
